/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable max-len */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-empty-interface */
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { Listbox, ListboxChangeEvent } from "primeng/listbox";
import { WrapperComponent } from "../base";
import { Wrapper } from "../decorators";

@Component({
    selector:      'gc-listbox',
    encapsulation: ViewEncapsulation.None,
    template:      `<label *ngIf="label !== undefined" [for]="__internal_ID">{{ label }}</label>
                    <p-listbox [formControl]="gcControl" [id]="__internal_ID"><ng-content></ng-content></p-listbox>`,
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: GcListboxComponent, multi: true }],
    inputs:    ["aruiaFilterLabel", "checkbox", "dataKey", "disabled", "filter", "filterMatchMode", "filterValue", "filterLocale", "filterBy", "filterPlaceHolder",
        "emptyFilterMessage", "listStyle", "listStyleClass", "metaKeySelection", "multiple", "readonly", "emptyMessage", "emptyFilterMessage", "options", "optionLabel",
        "optionValue", "optionDisabled", "optionGroupLabel", "optionGroupChildren", "group", "showToggleAll", "style", "styleClass"
    ],
    outputs: [
        "onChange", "onDblClick", "onClick"
    ],
    standalone: false
})
@Wrapper(Listbox)
export class GcListboxComponent extends WrapperComponent {
    @Input() label: string;
    @Output() onChange = new EventEmitter<ListboxChangeEvent>();
}
